import React from 'react';
// Import Libraries
import { createRoot } from 'react-dom/client';
// Import Main component
import Controller from '../customer_pages/_welcome-back-notification/welcome-back-notification';

createRoot(document.getElementById('welcome-back-notification')).render(
  <Controller />,
);
